import React from "react";
import { Icon } from "../../icons/icons";
import SliderFormDatepicker from "../Index/SliderFormDatepicker";
import SliderFormSelect from "../Index/SliderFormSelect";
import FormCustomer from "./FormCustomer";
import { useTranslation } from "../../context/TranslationContext";
const TopSearchBarContent = ({
  setParam,
  isMobile,
  onClick,
  RoutingTypeId,
  PageId,
}) => {
  const {
    SearchResultTitle,
    destination,
    villaOptions,
    checkInOutDate,
    searchUpper,
  } = useTranslation();
  return (
    <div className="lg:bg-list-searchBar-bg relative lg:py-7">
      <div className="container flex flex-col lg:flex-row ">
        <div className="bg-white pb-16 pt-6 lg:px-9 lg:py-0 flex-1 flex lg:items-center flex-col lg:flex-row  min-w-0">
          <div className="hidden xl:flex xl:mr-20 2xl:mr-40 items-center lg:items-start ">
            <div className="listIcons">
              <Icon name={"search"}></Icon>
            </div>
            <span className="font-bold ml-6 lg:w-32 leading-4 text-brand-black">
              {SearchResultTitle}
            </span>
          </div>
          <div className="flex flex-1 min-w-0 flex-col lg:flex-row ">
            <SliderFormSelect
              label={destination}
              className="w-full lg:w-1/4 relative field-border transition-all py-2.5"
              data={"/GetSearchBoxData?table=destinations"}
              name="bolge"
              setParam={setParam}
              selected={RoutingTypeId == "ProductDestination" ? PageId : null}
            />
            <SliderFormSelect
              label={villaOptions}
              className="w-full lg:w-1/4 relative field-border transition-all py-2.5"
              data={"/GetSearchBoxData?table=tip"}
              name="tip"
              setParam={setParam}
              selected={RoutingTypeId == "ProductCategory" ? PageId : null}
            />
            <SliderFormDatepicker
              label={checkInOutDate}
              setParam={setParam}
              className="w-full lg:w-1/4 relative field-border transition-all py-2.5"
            />
            <FormCustomer isMobile={isMobile} setParam={setParam} />
          </div>
        </div>

        <button
          type={isMobile ? "button" : "submit"}
          onClick={() => {
            isMobile && onClick ? onClick() : "";
          }}
          className="bg-primary py-4 lg:py-0 text-white lg:w-32 font-bold mt-auto lg:mt-0"
        >
          {searchUpper}
        </button>
      </div>
    </div>
  );
};

export default TopSearchBarContent;
